module.exports = __webpack_public_path__ + "img/israel.cd930bd6.png";